import {NgModule} from '@angular/core';
import {TempSaleRoutingModule} from './temp-sale-routing.module';

@NgModule({
  imports: [
    TempSaleRoutingModule
  ]
})
export class TempSaleModule {
}
